import forEach from 'lodash/forEach';
import Constants from './Constants';

const giftCardValidation = (giftcard) => {
    if (!giftcard) {
        return { giftCardNumError: Constants.CARD_ERROR };
    }
    if (giftcard.length !== 19) {
        return { giftCardNumError: Constants.CARD_ERROR };
    }
    return { giftCardNumError: Constants.BLANK };
};

const giftCardPinValidation = (pin) => {
    if (!pin) {
        return { giftCardPinError: Constants.PIN_ERROR };
    }
    if (pin.length !== 4) {
        return { giftCardPinError: Constants.PIN_ERROR };
    }
    return { giftCardPinError: Constants.BLANK };
};

const dynamicSchema = {
    giftCardNum: giftCardValidation,
    giftCardPin: giftCardPinValidation,
};

export function runSingleValidator(fieldName, data) {
    let result = {};
    if (dynamicSchema[fieldName] !== undefined) {
        result = dynamicSchema[fieldName](data[fieldName]);
    }
    return result;
}

export function runValidator(data) {
    const result = {};
    forEach(Object.keys(dynamicSchema), (validator) => {
        // key: the name of the object key
        // index: the ordinal position of the key within the object
        Object.assign(result, dynamicSchema[validator](data[validator]));
    });
    return result;
}
